<template>
  <div>
    <live-camera-grid-view
      :mode="'realtime'"
    />
  </div>
</template>

<script>
// モジュール
import LiveCameraGridView from "./CameraView.vue";

export default {
  components: {
    LiveCameraGridView,
  },
};
</script>
